import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Ridicare',
        [ORDER_METHODS.DELIVERY]: 'Livrare',
        [ORDER_METHODS.ON_SITE]: 'Comandă la masă',
      },
    },
    delivery_info: {
      title: 'Detalii livrare',
      on_arrival: 'La sosire:',
    },
    customer_info: {
      title: 'Contact',
    },
    payment: {
      title: 'Plată',
    },
    request_invoice: {
      title: 'Solicitare factură',
      form: {
        is_receipt_required: {
          label: 'Solicită factură prin email',
        },
      },
    },
    location: {
      title: 'Adresa magazinului',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Adresă de livrare',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Masa ta',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Adresă de ridicare',
      },
    },
    method: {
      title: 'Metodă',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Livrare',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Comandă la masă',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Ridicare',
      },
    },
    time: {
      title: 'Oră',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Standard {{time}} min, Azi',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Programează pentru mai târziu',
        },
      },
    },
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Sună la interfon',
        [DropoffAction.Sms]: 'Contactează-mă prin SMS la sosire',
      },
    },
    doorbell_name: {
      placeholder: 'Nume interfon (opțional)',
    },
    company_name: {
      placeholder: 'Nume companie (opțional)',
    },
    customer_note: {
      placeholder: 'Ai vreo notă pentru restaurant?',
    },
  },
  buttons: {
    change: 'Schimbă',
    edit: 'Editează',
    done: 'Gata',
    add_delivery_note: '+ Adaugă detalii livrare',
    add_order_note: '+ Adaugă o notă la comandă',
  },
  summary: {
    doorbell: 'Interfon',
    company: 'Companie',
    note: 'Notă comandă',
  },
};
